import { useCallback, useMemo } from 'react';

import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

import Grid from '@mui/material/Grid2';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import DeleteForeverOutlinedIcon from '@mui/icons-material/DeleteForeverOutlined';

// import SearchFilterBar, {
//   resolveQuickSearch,
//   type FilterStateType,
//   type QuickFiltersType,
// } from 'src/components/SearchFilterBar';

import DataTable from 'src/components/DataTable';
import ConfirmationDialog from 'src/components/ConfirmationDialog';
import { useDeleteTutorial, useGetTutorials } from 'src/pages/SetupPage/api';

import messages from './messages';
import TutorialForm from './components/TutorialForm';

export default function Tutorials() {
  const { formatMessage } = useIntl();

  // const [filters, setFilters] = useState<FilterStateType>({});

  // const [selectedTutorial, setSelectedTutorial] =
  //   useState<UCM.TutorialType | null>(null);

  const { mutate: deleteTutorial } = useDeleteTutorial();
  const { data: tutorials, isFetching: isFetchingTutorials } =
    useGetTutorials();

  // const searchFilters = useRef([
  //   {
  //     autoFocus: true,
  //     id: 'quick_search',
  //     type: 'text' as QuickFiltersType['type'],
  //     placeholder: formatMessage(messages.searchPlaceholder),
  //   },
  // ]).current;

  const columns: Array<{
    id: keyof UCM.TutorialType | string;
    label: string | React.ReactNode;
  }> = useMemo(() => {
    return [
      {
        id: 'code',
        label: formatMessage(messages.codeColumnLabel),
        render: (code: string, tutorial: UCM.TutorialType) => (
          <Link to={`/tutorial_details/${tutorial.uuid}`}>{code}</Link>
        ),
      },
      {
        id: 'title_en',
        label: formatMessage(messages.titleEnColumnLabel),
        render: (_: Object, tutorial: UCM.TutorialType) => (
          <Typography variant="inherit">{tutorial.title.en}</Typography>
        ),
      },
      {
        id: 'title_de',
        label: formatMessage(messages.titleDeColumnLabel),
        render: (_: Object, tutorial: UCM.TutorialType) => (
          <Typography variant="inherit">{tutorial.title.de}</Typography>
        ),
      },
      {
        id: 'kind',
        align: 'center',
        label: formatMessage(messages.kindColumnLabel),
        render: (kind: UCM.TutorialType['kind']) => (
          <Typography variant="inherit">{kind.name ?? '-'}</Typography>
        ),
      },
      {
        id: 'cohort',
        align: 'center',
        label: formatMessage(messages.cohortColumnLabel),
        render: (cohort: UCM.TutorialType['cohort']) => (
          <Typography variant="inherit">{cohort.name ?? '-'}</Typography>
        ),
      },
      {
        id: 'actions',
        label: '',
        align: 'center',
        width: 0,
        render: (_: Object, tutorial: UCM.TutorialType) => (
          <Grid display="flex" alignItems="center">
            <TutorialForm create={false} tutorial={tutorial} />

            {tutorial.deletable && (
              <ConfirmationDialog
                onConfirm={() => handleDelete(tutorial.uuid)}
                message={formatMessage(messages.deleteTutorialConfirmation)}
              >
                {(handleOpen) => (
                  <Tooltip arrow title={formatMessage(messages.deleteTooltip)}>
                    <IconButton onClick={handleOpen}>
                      <DeleteForeverOutlinedIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </ConfirmationDialog>
            )}
          </Grid>
        ),
      },
    ];
  }, []);

  // const handleSearch = useCallback((filters: FilterStateType) => {
  //   setFilters(filters);
  // }, []);

  const handleDelete = useCallback((tutorialUuid: string) => {
    deleteTutorial(tutorialUuid);
  }, []);

  return (
    <Grid container spacing={2} size={12}>
      {/* <Grid size={{ xs: 12, md: 4 }}>
          <SearchFilterBar
            variant="noBorder"
            fields={searchFilters}
            onSearch={handleSearch}
          />
        </Grid> */}

      <Grid
        display="flex"
        alignItems="center"
        justifyContent="flex-end"
        // size={{ xs: 12, md: 8 }}
        size={12}
        // justifyContent={{ xs: 'flex-start', md: 'flex-end' }}
      >
        <TutorialForm create={true} />
      </Grid>

      <Grid size={12}>
        <DataTable
          rows={tutorials}
          columns={columns}
          enabledFooter={false}
          loading={isFetchingTutorials}
        />
      </Grid>
    </Grid>
  );
}
